import { createRoute, getPathForAllPortals } from "utilities/flatRoutes/routes";

interface IAiBidPackageSuggestionsParams {
    jobId: number;
}

interface IAiBidPackageSuggestionDetailParams extends IAiBidPackageSuggestionsParams {
    suggestionKey: string;
}

// One registered path for review and detail, so the page stays mounted and keeps its session
// state while moving between them.
export const aiBidPackageSuggestionsPagePath = getPathForAllPortals(
    "/BidPackages/Suggest/:jobId/:suggestionKey?",
);

export const aiBidPackageSuggestionsRoute = createRoute<IAiBidPackageSuggestionsParams>(
    getPathForAllPortals("/BidPackages/Suggest/:jobId"),
    "New bid packages",
);

export const aiBidPackageSuggestionDetailRoute = createRoute<IAiBidPackageSuggestionDetailParams>(
    getPathForAllPortals("/BidPackages/Suggest/:jobId/:suggestionKey"),
    "New bid package",
);
